import React from 'react';
import * as Config from '../../config';
import LoginPage from '../../scenes/login_page';
import MainPage from '../../scenes/main_page';
import Dashboard from '../../scenes/dashboard';
import RegistrationListPage from '../../scenes/registration_list_page';
import VatReturnsPage from '../../scenes/vatreturns_page';
import RegisterPage from '../../scenes/register_page';
import DatatablesPage from '../../scenes/datatables_page';
import RootPage from '../../scenes/root_page';
import AppbarMenu from '../components/appbar';
import ForgotPasswordPage from '../../scenes/forgot_password';
import MapsPage from '../../scenes/maps_page';
import ResetPasswordPage from '../../scenes/reset_password';
import RegistrationDetailPage from '../../scenes/registration_detail_page';
import ApplicantsPage from '../../scenes/applicants_page';
import NotificationsPage from '../../scenes/notification_page';
import VatReturnDetailPage from '../../scenes/vatreturn_detail_page';
import PaymentsListPage from '../../scenes/payments_list_page';
import PaymentInfoPage from '../../scenes/payment_info_page';
import MessageOutgoingPage from '../../scenes/message_outgoing_page';
import MessageIncomingPage from '../../scenes/message_incoming_page';
import RegistrationReceivedPage from '../../scenes/registration_received_page';
import RegistrationReceivedDetailPage from '../../scenes/registration_received_detail_page';
import RegistrationRequestPage from '../../scenes/registration_request_page';
import VatReturnRequestPage from '../../scenes/vatreturn_request_page';
import VatReturnRemindersPage from '../../scenes/vatReturn_reminders_page';
import PaymentRemindersMsidPage from '../../scenes/payment_reminders_page';
import PaymentRemindersMsconPage from '../../scenes/payment_reminders_mscon_page';
import PaymentCentralBankPage from '../../scenes/payment_central_bank_page';
import VatReturnReceivedPage from '../../scenes/vatreturns_received_list_page';
import PaymentReceivedPage from '../../scenes/payments_received_list_page';
import RemindersMsconReceivedPage from '../../scenes/reminders_mscon_received_list_page';
import RemindersMsidReceivedPage from '../../scenes/reminders_msid_received_list_page';
import ReimbursementsReceivedPage from '../../scenes/reimbursements_received_list_page';
import ReimbursementsPage from '../../scenes/reimbursements_list_page';
import ReimbursementsMsconPage from '../../scenes/reimbursements_mscon_list_page';
import VatRatesPage from '../../scenes/vat_rates_page';
import CentralBankPaymentListReducer from 'redux/reducers/payment_central_bank_reducer/reducer';

interface IPage {
  path: string;
  component: any;
  roles: Array<number>;
}

interface INavigationConfig {
  rootPage: () => IPage;
  mainPage: () => IPage;
  loginPage: () => IPage;
  registerPage: () => IPage;
  dashboardPage: () => IPage;
  forgotPasswordPage: () => IPage;
  resetPasswordPage: (token?: string) => IPage;
  datatablesPage: () => IPage;
  mapsPage: () => IPage;
  registrationDetailPage: (
    id?: string,
    detail?: 'view' | 'edit' | ':detail'
  ) => IPage;
  registrationListPage: () => IPage;
  vatReturnsPage: () => IPage;
  vatReturnDetailPage: (
    id?: string,
    detail?: 'view' | 'edit' | ':detail'
  ) => IPage;
  applicantsPage: () => IPage;
  notificationsPage: () => IPage;
  paymentsPage: () => IPage;
  paymentInfoPage: () => IPage;
  messageOutgoingPage: () => IPage;
  messageIncomingPage: () => IPage;
  registrationReceivedPage: () => IPage;
  registrationReceivedDetailPage: (id?: string) => IPage;
  registrationRequest: () => IPage;
  vatReturnRequest: () => IPage;
  vatReturnRemindersPage: () => IPage;
  paymentRemindersMsidPage: () => IPage;
  paymentRemindersMsconPage: () => IPage;
  paymentCentralBankPage: () => IPage;
  vatReturnReceivedPage: () => IPage;
  paymentReceivedPage: () => IPage;
  remindersMsconReceivedPage: () => IPage;
  remindersMsidReceivedPage: () => IPage;
  reimbursementsReceivedPage: () => IPage;
  reimbursementsPage: () => IPage;
  reimbursementsMsconPage: () => IPage;
  vatRatesPage: () => IPage;
}

interface IAppbarsConfig {
  primaryNav: INav;
  secondaryNav: INav;
}

interface INav {
  component: any;
  include: 'all' | string[] | null;
  exclude: 'all' | string[] | null;
  select: 'include' | 'exclude';
  // roles: Array<string>;
}

const NavigationConfig: INavigationConfig = {
  rootPage: (params?: any): IPage => ({
    path: '*',
    component: RootPage,
    roles: Config.AuthRoles.All,
  }),
  mainPage: (params?: any) => ({
    path: `/`,
    component: MainPage,
    roles: Config.AuthRoles.All,
  }),
  loginPage: () => ({
    path: '/login',
    component: LoginPage,
    roles: [Config.AuthRoles.Guest],
  }),
  registerPage: () => ({
    path: '/register',
    component: RegisterPage,
    roles: [Config.AuthRoles.Guest],
  }),
  dashboardPage: () => ({
    path: '/dashboard',
    component: Dashboard,
    roles: Config.AuthRoles.Registered,
  }),
  forgotPasswordPage: () => ({
    path: '/forgot',
    component: ForgotPasswordPage,
    roles: Config.AuthRoles.All,
  }),
  resetPasswordPage: (token = ':token') => ({
    path: `/reset-password/${token}`,
    component: ResetPasswordPage,
    roles: Config.AuthRoles.All,
  }),
  mapsPage: () => ({
    path: '/maps',
    component: MapsPage,
    roles: Config.AuthRoles.Registered,
  }),
  datatablesPage: () => ({
    path: '/datatables',
    component: DatatablesPage,
    roles: Config.AuthRoles.Registered,
  }),
  registrationDetailPage: (id = ':id', detail = ':detail') => ({
    path: `/registration/${detail}/${id}`,
    component: RegistrationDetailPage,
    roles: Config.AuthRoles.Registered,
  }),
  registrationListPage: () => ({
    path: `/registration`,
    component: RegistrationListPage,
    roles: Config.AuthRoles.Registered,
  }),
  vatReturnDetailPage: (id = ':id', detail = ':detail') => ({
    path: `/vat-return/${detail}/${id}`,
    component: VatReturnDetailPage,
    roles: Config.AuthRoles.Registered,
  }),
  vatReturnsPage: () => ({
    path: `/vat-return`,
    component: VatReturnsPage,
    roles: Config.AuthRoles.Registered,
  }),
  applicantsPage: () => ({
    path: `/applicants`,
    component: ApplicantsPage,
    roles: [Config.AuthRoles.Admin, Config.AuthRoles.Agent],
  }),
  notificationsPage: () => ({
    path: `/notifications`,
    component: NotificationsPage,
    roles: Config.AuthRoles.Registered,
  }),
  paymentsPage: () => ({
    path: `/payments`,
    component: PaymentsListPage,
    roles: Config.AuthRoles.Registered,
  }),
  paymentInfoPage: () => ({
    path: `/payment-info`,
    component: PaymentInfoPage,
    roles: [Config.AuthRoles.Admin],
  }),
  messageOutgoingPage: () => ({
    path: `/message-ougoing`,
    component: MessageOutgoingPage,
    roles: [Config.AuthRoles.Admin],
  }),
  messageIncomingPage: () => ({
    path: `/message-incoming`,
    component: MessageIncomingPage,
    roles: [Config.AuthRoles.Admin],
  }),
  registrationReceivedPage: () => ({
    path: `/registration-received`,
    component: RegistrationReceivedPage,
    roles: [Config.AuthRoles.Admin],
  }),
  registrationReceivedDetailPage: (id = ':id') => ({
    path: `/registration-received/${id}`,
    component: RegistrationReceivedDetailPage,
    roles: [Config.AuthRoles.Admin],
  }),
  registrationRequest: () => ({
    path: `/registration-request`,
    component: RegistrationRequestPage,
    roles: [Config.AuthRoles.Admin],
  }),
  vatReturnRequest: () => ({
    path: `/vatReturn-request`,
    component: VatReturnRequestPage,
    roles: [Config.AuthRoles.Admin],
  }),
  vatReturnRemindersPage: () => ({
    path: `/vat-return-reminders`,
    component: VatReturnRemindersPage,
    roles: [Config.AuthRoles.Admin],
  }),
  paymentRemindersMsidPage: () => ({
    path: `/payment-reminders-msid`,
    component: PaymentRemindersMsidPage,
    roles: [Config.AuthRoles.Admin],
  }),
  paymentRemindersMsconPage: () => ({
    path: `/payment-reminders-mscon`,
    component: PaymentRemindersMsconPage,
    roles: [Config.AuthRoles.Admin],
  }),
  vatReturnReceivedPage: () => ({
    path: `/vat-return-received`,
    component: VatReturnReceivedPage,
    roles: [Config.AuthRoles.Admin],
  }),
  paymentReceivedPage: () => ({
    path: `/payment-received`,
    component: PaymentReceivedPage,
    roles: [Config.AuthRoles.Admin],
  }),
  remindersMsconReceivedPage: () => ({
    path: `/reminders-mscon-received`,
    component: RemindersMsconReceivedPage,
    roles: [Config.AuthRoles.Admin],
  }),
  remindersMsidReceivedPage: () => ({
    path: `/reminders-msid-received`,
    component: RemindersMsidReceivedPage,
    roles: [Config.AuthRoles.Admin],
  }),
  reimbursementsReceivedPage: () => ({
    path: `/reimbursements-received`,
    component: ReimbursementsReceivedPage,
    roles: [Config.AuthRoles.Admin],
  }),
  reimbursementsPage: () => ({
    path: `/reimbursements`,
    component: ReimbursementsPage,
    roles: [Config.AuthRoles.Admin],
  }),
  reimbursementsMsconPage: () => ({
    path: `/reimbursements-mscon`,
    component: ReimbursementsMsconPage,
    roles: [Config.AuthRoles.Admin],
  }),
  paymentCentralBankPage: () => ({
    path: `/payment-central-bank`,
    component: PaymentCentralBankPage,
    roles: [Config.AuthRoles.Admin],
  }),
  vatRatesPage: () => ({
    path: `/vat-rates`,
    component: VatRatesPage,
    roles: [Config.AuthRoles.Admin],
  }),
};

export const AppbarsConfig: IAppbarsConfig = {
  primaryNav: {
    component: AppbarMenu,
    include: null,
    exclude: [
      NavigationConfig.loginPage().path,
      NavigationConfig.registerPage().path,
      NavigationConfig.forgotPasswordPage().path,
      NavigationConfig.resetPasswordPage().path,
    ],
    select: 'exclude',
  },
  secondaryNav: {
    component: AppbarMenu,
    include: [],
    exclude: 'all',
    select: 'exclude',
  },
};

export const Appbars: Array<INav> = Object.values(AppbarsConfig);
export default NavigationConfig;
